import { IEqFundWithdrawPayOutMsgEntiesMain } from "@/api/domains/features/FundTransfer/entities/IEqFundWithdrawPayOutMsg";
import EdButton, {
  IEdButtonProps,
} from "@/components/generic/edbutton/edButton";


interface IFundtransferBtn {
  parentClass?: string;
  btnvalueleft?: IEdButtonProps;
  btnvalueright?: IEdButtonProps;
  eqFundpayoutMessage?: IEqFundWithdrawPayOutMsgEntiesMain;
}

const FundtransferBtn = (props: IFundtransferBtn) => {
  return (
    <>
      <div className={`${props.parentClass} bottombtngroup`}>
        <>
          {props?.eqFundpayoutMessage && (
            <>
              {" "}
              <div className="payoutRow mt-2 mb-md-2 mb-3">
                <div className="leftSection">
                  <div
                    className="payout-inner-section"
                    style={{
                      background: `${props?.eqFundpayoutMessage?.color}1A`,
                    }}
                  >
                    <span
                      className="payoutstatus-text"
                      style={{ color: props?.eqFundpayoutMessage?.color }}
                    >
                      {props?.eqFundpayoutMessage?.longMessage}
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}

          <div className="justify-content-around align-content-center d-flex">
            {props.btnvalueleft && <EdButton {...props.btnvalueleft} />}
            {props.btnvalueright && <EdButton {...props.btnvalueright} />}
          </div>
        </>
      </div>
    </>
  );
};

export default FundtransferBtn;

